import React from "react";
import GeofenceMap from "@/components/GeofenceMap";
import { TroubleshootingMapModel } from "@/utils/troubleshooting.utils";

interface TroubleshootingMapProps {
  model: TroubleshootingMapModel;
  labels: {
    primary: string;
    secondary: string;
    event: string;
    radius: string;
    openInGoogleMaps: string;
  };
  height?: number;
}

/**
 * COYN-1507 §17: the troubleshooting maps reuse the geofence detail map
 * as-is (same tiles and the same "Open in Google Maps" link), adding the
 * SDK centres / extra radius circles and fitting the view to every point.
 */
const TroubleshootingMap: React.FC<TroubleshootingMapProps> = ({
  model,
  labels,
  height = 260,
}) => (
  <GeofenceMap
    primary={model.primary}
    secondary={model.secondary}
    event={model.event}
    activeCenter={model.activeCenter}
    radiusMeters={model.radiusMeters}
    extraPoints={model.extraPoints}
    extraCircles={model.extraCircles}
    fitAllPoints
    labels={labels}
    height={height}
  />
);

export default TroubleshootingMap;
